export interface ITalkerProps {
  id?: string
  type: string | null
  fullname: string | null
  organization: string | null
  icon: string | null
}

export default class TalkerEntity {
  private _props: ITalkerProps

  constructor(props?: ITalkerProps | null) {
    this._props = EmptyTalkerPropsFactory(props)
  }

  get props(): ITalkerProps {
    return this._props
  }

  get clone(): ITalkerProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get type(): string | null {
    return this._props.type
  }

  get fullname(): string | null {
    return this._props.fullname
  }

  get organization(): string | null {
    return this._props.organization
  }

  get icon(): string | null {
    return this._props.icon
  }

  get color(): string | null {
    const code = this.fullname?.charCodeAt(0)
    if (code) {
      return colors[code % colors.length]
    }
    return 'grey'
  }

  get initial(): string {
    return this.fullname?.charAt(0) || ''
  }
}

export const headers = [{ text: 'ID', value: 'id' }]
export const colors = ['#1976D2', '#388E3C', '#F57C00', '#7B1FA2', '#C2185B', '#00796B']

export const EmptyTalkerPropsFactory = (props?: Partial<ITalkerProps> | null): ITalkerProps => ({
  type: null,
  fullname: null,
  organization: null,
  icon: null,
  ...props
})
